export default function (state, getters, rootState, rootGetters) {
    let setting = rootState.settings.invoices;
    let from = (state.page - 1) * setting.col + 1;
    let to = (state.page * setting.col) > state.items.length ? state.items.length : state.page * setting.col;
    return from + ' - '+ to + ' из ' + state.items.length;
}
